import React from 'react';
import styled from '@emotion/styled/macro';
import { defineResponsiveGridColumns } from '@utils/utils';
import vars from '@variables';

const SearchIntro = ({ introText, className }) => {
  return (
    <div className={className}>
      <div id="content-hub-intro">{introText}</div>
    </div>
  );
};

const StyledSearchIntro = styled(SearchIntro)`
  display: grid;
  width: 100%;
  margin: 0 auto;
  max-width: ${vars.mainMaxWidth};
  column-gap: ${vars.mobileColumnPercentageGap};
  grid-template-columns: ${defineResponsiveGridColumns(4)};

  @media screen and (min-width: ${vars.breakPointTablet}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(8)};
  }

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(12)};
  }

  div {
    margin-bottom: ${vars.spacingS};
    margin-top: ${vars.spacingS};
    background-color: ${vars.white};
    font-size: ${vars.fontSize4};
    grid-column: col1-start / col4-end;

    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col2-start / col7-end;
      margin-bottom: ${vars.spacingS};
    }

    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      grid-column: col3-start / col10-end;
      margin-bottom: ${vars.spacingS};
    }
  }
`;

export default StyledSearchIntro;
